module.exports = __webpack_public_path__ + "static/couple-couch.6657bc2a.jpg";